"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import { useMutation } from "@apollo/client/react"
import get from "lodash/get"
import { useRouter } from "next/navigation"
import updateWarningMessage from "../graphql/mutations/snackbarMessage/updateWarningMessage"
import updateMe from "../graphql/mutations/updateMe"
import updateErrorMessage from "../graphql/mutations/snackbarMessage/updateErrorMessage"
import updateSuccessMessage from "../graphql/mutations/snackbarMessage/updateSuccessMessage"
import useSessionAttributes from "../lib/auth/useSessionAttributes"

const FAILED_UPDATE_ME_NEWSLETTER =
  "Unable to update your newsletter preference. Please contact support."
// This hook is used on the leader landing page. if you are
export default function useRedirectToLeaderOnboarding() {
  const { userId } = useSessionAttributes()

  const isLoggedIn = userId ? true : false

  const router = useRouter()
  const [updateMeFunc] = useMutation(updateMe)

  const getRouteForLeaderOnboarding = () => {
    if (isLoggedIn) {
      return "/dashboard"
    }
    return "/signup?redirect_to_leader=true"
  }

  const handleUpdateMeNewsLetter = async () => {
    try {
      const { error } = await updateMeFunc({
        variables: {
          input: {
            newsletter: true,
          },
        },
      })
      if (error) {
        throw error
      } else {
        updateSuccessMessage("You are now signed up for the newsletter!")
      }
    } catch (error) {
      updateErrorMessage(
        get(error, "message", FAILED_UPDATE_ME_NEWSLETTER) ||
          FAILED_UPDATE_ME_NEWSLETTER,
      )
    }
  }
  const getMonthlyListingsClickHandler = async () => {
    // if logged in, then make call to update user to have monthly listing set to true.
    if (isLoggedIn) {
      router.push("/account/notifications")
      // await handleUpdateMeNewsLetter()
    } else {
      // if not logged in then push them to sign up
      updateWarningMessage("Log in or create account to get monthly listings")
      router.push("/signup?redirect_to_leader=true&newsletter=true")
    }
  }

  return [
    { isLoggedIn },
    { getRouteForLeaderOnboarding, getMonthlyListingsClickHandler },
  ]
}
